import useApi from "@/hooks/api/useApi";

export interface HistoryProtocolData {
  timestamp: number[] | null;
  tvl: number[] | null;
}

export interface ProtocolData {
  historical_data: HistoryProtocolData;
  total_vaults: number;
  tvl: number;
  tvl_24h_change: number;
}

/**
 * @package api:go
 * @link https://superform-xyz.postman.co/workspace/Superform~fe57d318-f198-4f97-9c50-0b2a5a78dbac/request/3472327-e09f9afd-a23f-4562-a5fe-024b18ba20b4?ctx=documentation
 */
export default function useProtocolStats(protocolId: string | undefined, forced: boolean = false) {
  const { data, isLoading, isError, mutate } = useApi<ProtocolData, ProtocolData>(
    {
      path: `/protocol/${protocolId}/stats/`,
      api: "v2",
    },
    {
      enabled: !!protocolId,
      strategy: forced ? "cached" : "default",
    }
  );

  return {
    data,
    isLoading,
    isError,
    mutate,
  };
}
